import {
  VideoEmbed,
  VideoEmbedPreviewPlayButtonStyle,
} from "@components/VideoEmbed";
import type { CSSInterpolation } from "@emotion/serialize";
import { useRouter } from "next/router";
import React from "react";

interface UpdatePostVideoPreviewProps {
  containerCss?: CSSInterpolation;
  postUrl: string;
  title: string;
  videoUrl: string;
}

export const UpdatePostVideoPreview = ({
  containerCss,
  postUrl,
  title,
  videoUrl,
}: UpdatePostVideoPreviewProps) => {
  const router = useRouter();

  return (
    <VideoEmbed
      videoUrl={videoUrl}
      borderRadius="8px"
      containerCss={[containerCss, { zIndex: 2 }]}
      isPreview
      onPreviewClick={() => router.push(`${postUrl}?autoplayVideo=true`)}
      previewFillsContainer
      previewPlayButtonStyle={VideoEmbedPreviewPlayButtonStyle.YOUTUBE}
      title={`${title} cover video`}
    />
  );
};
